exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__detailsItem___24nXs{font-size:14px;letter-spacing:.2px;margin:0 0 40px;color:#333}.style__title___1l5v-{font-family:PlayfairDisplay-Regular;color:#c1887f;font-size:18px;margin-bottom:4px;letter-spacing:1px}.style__detailsItem___24nXs a{color:#c9877d;text-decoration:none}.style__detailsItem___24nXs a:hover{text-decoration:underline}", ""]);

// exports
exports.locals = {
	"detailsItem": "style__detailsItem___24nXs",
	"title": "style__title___1l5v-"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/details-item/style.css
// module id = 682
// module chunks = 0